/* eslint-disable import/no-default-export */
export interface GetMsParams {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
  ms?: number;
  years?: number;
  months?: number;
  weeks?: number;
}

export default ({
  days = 0,
  hours = 0,
  minutes = 0,
  seconds = 0,
  ms = 0,
  years,
  months,
  weeks,
}: GetMsParams): number => {
  let tempDays = days;
  let tempHours = hours;
  let tempMinutes = minutes;
  let tempSeconds = seconds;
  let tempMs = ms;

  if (years) {
    tempDays += years * 365;
  }

  if (months) {
    tempDays += months * 30;
  }

  if (weeks) {
    tempDays += weeks * 7;
  }

  tempHours += tempDays * 24;
  tempMinutes += tempHours * 60;
  tempSeconds += tempMinutes * 60;

  tempMs += tempSeconds * 1000;

  return tempMs;
};
